import * as React from 'react';
import styled, { css } from 'styled-components';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import { FormattedMessage } from 'react-intl';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    badgeStyle?: boolean;
    className?: string;
    imageSize?: string;
};

const TopBadge = ({ className = '', imageSize = '' }: Props) => {
    const badge = (
        <StyledPopover
            hover
            hoverHideDelay={500}
            hoverShowDelay={0}
            placement="bottom"
            trigger={
                <StyledActionText $useBadgeStyle>
                    <img alt="badge" className={imageSize} src="https://p1.liveauctioneers.com/dist/images/badge.svg" />{' '}
                    <FormattedMessage id="top" />
                </StyledActionText>
            }
        >
            <PopoverContentContainer>
                <TopHeading lineHeight={18} secondary>
                    <StyledImg alt="badge" src="https://p1.liveauctioneers.com/dist/images/badge.svg" />
                    <FormattedMessage id="top_rated_header" />
                </TopHeading>
                <TopParagraph secondary>
                    <FormattedMessage id="top_message" />
                </TopParagraph>
            </PopoverContentContainer>
        </StyledPopover>
    );

    return <ContainerSpan className={className}>{badge}</ContainerSpan>;
};

export default React.memo<Props>(TopBadge);

const ContainerSpan = styled.span`
    cursor: pointer;
`;

const StyledPopover = styled(Popover)`
    width: 256px;
`;

const PopoverContentContainer = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
`;

const TopParagraph = styled(Text)`
    letter-spacing: 0;
    margin-top: 5px;
    max-width: 100%;
    white-space: initial;
`;

const TopHeading = styled(Text)`
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 1px;
`;

const StyledImg = styled.img`
    width: 25px;
    height: 24px;
    margin-top: 10px;
    margin-right: 9px;
`;

const TopSpanStyle = css`
    &&& {
        font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
        font-size: 12px;
        letter-spacing: 0.7px;
        color: ${({ theme }) => theme.colors.orange100};
        vertical-align: middle;
        display: inline-flex;
        justify-content: space-evenly;
        align-items: center;
    }
`;

const StyledActionText = styled(ActionText)<{ $useBadgeStyle: boolean }>`
    width: 106px;
    ${({ $useBadgeStyle }) => $useBadgeStyle && TopSpanStyle}
`;
